<div class="wrapper">
  <div class="page-header" style="background-image: url('./assets/img/landing2.webp');">
    <div class="filter"></div>
    @if (mode=='signin') {
      <app-signin (goTo)="goTo($event)" (callbackFunction)="callbackSignin($event)"></app-signin>
    }
    @if (mode=='signup') {
      <app-signup (goTo)="goTo($event)" (callbackFunction)="callbackSignup($event)"></app-signup>
    }
    @if (mode=='reset') {
      <app-forgot-password (goTo)="goTo($event)" (callbackFunction)="callbackReset($event)"></app-forgot-password>
    }
  </div>
</div>
